module.exports = __webpack_public_path__ + "wxMicroService/img/1.a0b334fd.png";